import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RETRY_DELAYS = [140, 360, 760];

const RouteScrollManager: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const targetId = decodeURIComponent(location.hash.replace(/^#/, ""));

    if (!targetId) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return;
    }

    let cancelled = false;
    let animationFrame = 0;
    let nestedAnimationFrame = 0;
    let lastTargetTop: number | null = null;
    const timers: number[] = [];

    const scrollToTarget = (force = false) => {
      if (cancelled) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      const absoluteTop = target.getBoundingClientRect().top + window.scrollY;
      const layoutMoved =
        lastTargetTop === null || Math.abs(absoluteTop - lastTargetTop) > 1;

      if (force || layoutMoved) {
        target.scrollIntoView({ block: "start", behavior: "auto" });
      }

      lastTargetTop = absoluteTop;
    };

    animationFrame = window.requestAnimationFrame(() => {
      nestedAnimationFrame = window.requestAnimationFrame(() =>
        scrollToTarget(true)
      );
    });

    RETRY_DELAYS.forEach((delay) => {
      timers.push(window.setTimeout(() => scrollToTarget(), delay));
    });

    document.fonts?.ready.then(() => scrollToTarget());

    return () => {
      cancelled = true;
      window.cancelAnimationFrame(animationFrame);
      window.cancelAnimationFrame(nestedAnimationFrame);
      timers.forEach((timer) => window.clearTimeout(timer));
    };
  }, [location.hash, location.key, location.pathname]);

  return null;
};

export default RouteScrollManager;
